import React from 'react';
import { CJ_LISTEN_YXHD_ZCHDBM } from '@/constants/scene';
import FeedBackLayout from '@/components/feedback-layout';
import Microapp from '@/components/micro-app';
import history from '@/history';
import env from '@/env';
import { showUserVoice } from '@/components/userVoice';

const MyJoinZongcuDetail = () => {
  const ref = React.useRef();
  function showFeedBack() {
    //@ts-ignore
    ref.current.show(true);
  }
  function goBackHDCenter() {
    history.replace('/activity-manage/myCreate/zongcuActivity/myJoin');
  }

  return (
    <>
      <FeedBackLayout showFeedBack={true} scene={CJ_LISTEN_YXHD_ZCHDBM.key} ref={ref} />
      <Microapp
        // http://mcbeta.jd.com/dist/pages/activeManageBlock/page?activityId=10593419
        url={env.MC_DOMAIN + '/unitiedMarketing'}
        name="activityManageZongcuDetail"
        data={{
          basename: '/activity-manage/myCreate/zongcuActivity/myJoin/detail',
          flag: 'myJoinCreate',
          goBackHDCenter,
          showFeedBack,
          showUserVoice,
        }}
      />
    </>
  );
};

export default MyJoinZongcuDetail;
